<ul role="group">
    <li class="group" role="heading" aria-level="2" *ngIf="group.columnHeading as columnHeading">
        <span class="group-main-link kk-hover-underline">
            <app-link [link]="columnHeading"></app-link>
        </span>
    </li>
    <li *ngFor="let link of group.links" aria-level="2">
        <span class="link kk-hover-underline">
            <app-link [link]="link"></app-link>
        </span>
    </li>
</ul>
